(function($) {
  var DialogFrame = function(element, options) {
    var elem = $(element);
    var obj = this;

    var settings = $.extend(
      {
        id: null,
        token: null,
        model: null,
        youtube: {
          api_key: '',
        },
        urls: {
        }
      },
      options || {},
    );

    /*
     * Public method
     * Can be called outside class
     */
    this.images = () => {
      $('#image-tabs a:first').tab('show');

      toggleInsertButton(false);

      bindImages();
      bindUpload();

      ajaxPagination({ target: '#attachments', links: '#attachments .pagination-container a' });
    };

    this.editImage = () => {
      bindImages();
    };

    this.youtube = () => {
      $('#video-tabs a:first').tab('show');

      toggleInsertVideoButton(false);

      loadVideo($('#youtube-url'));

      bindYoutube();
    };

    bindImages = () => {
      $('#container').on('click', '.attachment', function() {
        $(this)
          .parent('.attachments')
          .children('.attachment')
          .removeClass('selected');

        !$(this).hasClass('selected')
          ? $(this).addClass('selected')
          : $(this).removeClass('selected');

        selectAttachment($(this));

        return false;
      });

      $('#container').on('blur', '#resource-url', function() {
        let $e = $(this);

        console.info($e.val());

        if ($e.val().length == 0) {
          $('#resource-settings').addClass('d-none');
          toggleInsertButton(false);
        } else {
          $img = $('<img />')
            .prop('src', $e.val())
            .on('error', function() {
              toggleInsertButton(false);
              $e.parent('.form-group')
                .addClass('has-error')
                .find('.invalid-feedback')
                .html('Invalid image URL');
              $('#resource-settings').addClass('d-none');
              $('#resource-thumbnail').html('');
            })
            .on('load', function() {
              toggleInsertButton(true);
              $e.parent('.form-group')
                .removeClass('has-error')
                .find('.invalid-feedback')
                .html('');
              $('#resource-settings').removeClass('d-none');
              $('#resource-thumbnail').html($(this).addClass('img-fluid'));
            });
        }
      });

      $('.attachment-sidebar')
        .popover({
          html: true,
          //         title: function () {
          //             return $(this).parent().find('.head').html();
          //         },
          placement: 'bottom',
          container: '#container',
          selector: 'a#remove-file',
          content: function() {
            return $('div#popover-delete-image').html();
          },
        })
        .click(function(e) {
          e.preventDefault();
        });

      $('#container').on('click', '.cancel-delete', function() {
        console.info('cancel');
        $('a#remove-file').popover('hide');
      });

      $('#container').on('click', '.confirm-delete', function() {
        let $btn = $(this);

        ajaxRequest({
          url: $('a#remove-file').prop('href'),
          beforeSend: function(jqXHR, settings) {
            $('a#remove-file').html('<i class="spinners"></i>');
            $btn.addClass('disabled');
          },
          error: function(e) {
            $btn.removeClass('disabled');
            $('a#remove-file').html('Delete image');
            $('a#remove-file').popover('hide');
          },
          success: function(result) {
            $btn.removeClass('disabled');

            $('a#remove-file').html('Delete image');

            if (result.success) {
              $('a#remove-file').popover('hide');

              $('.attachment.selected[data-id="' + $('a#remove-file').data('id') + '"]').remove();

              $('.attachment-sidebar:first').html('');
            } else {
              $btn
                .parents('.popover-content')
                .find('.popover-action')
                .html(
                  '<div class="alert alert-danger p-2 m-0 text-left">' + result.message + '</div>',
                );
            }
          },
        });
      });
    };

    bindUpload = function() {
      // Change this to the location of your server-side upload handler:
      // let url = App.configs.siteUrl + '/files/picture';
      let url = settings.urls.image_upload;

      let picturePlaceholder = $('<div class="attachment"/>').append(
        $('<div class="progress"/>').append(
          $(
            '<div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />',
          ).append($('<span class="sr-only"/>')),
        ),
      );

      //var modalPicturePlaceholder = $('<div />').addClass('picture-select').append($('<div/>').addClass('progress progress-striped active').append($('<div/>').addClass('progress-bar progress-bar-info')));

      $('.fileupload')
        .fileupload({
          url: url,
          dataType: 'json',
          formData: { _token: settings.token },
          fail: function(e, data) {
            let msg = Messenger().post({
              message:
                data.jqXHR.responseJSON.message.length > 0
                  ? data.jqXHR.responseJSON.message
                  : data.jqXHR.responseJSON.exception,
              type: 'error',
              showCloseButton: true,
              hideAfter: 10,
              hideOnNavigate: true,
              id: '1',
            });

            data.context.remove();

            // $(this).parent('span').find('i, img').remove();
          },
          done: function(e, data) {
            if (data.result.success) {
              console.info(data.result.result);

              $.each(data.result.result, function(index, file) {
                data.context.attr('data-id', file.id);
                data.context.attr('data-path', file.base_path);
                data.context.attr('data-name', file.basename);
                data.context.attr('data-filename', file.path);
                data.context.attr('data-basename', file.basename);
                data.context.attr('data-ext', file.extension);
                data.context.attr('data-dimension', file.dimension.join('x'));
                data.context.attr('data-url-remove', file.urls.remove);
                data.context.children('.progress').remove();
                data.context.prepend(
                  $('<div class="thumb" />').append(
                    $('<div class="centered"/>').append(
                      $('<img class="img-fluid"/>').prop('src', file.image.normal),
                    ),
                  ),
                );

                // if($('#product-pictures:visible').length > 0) {
                //     $('#product-pictures').append($('<div />').addClass('picture-select').attr('data-id', file.id).append($('<img/>').attr('src', file.url_small)));
                // }
              });
            } else {
              let msg = Messenger().post({
                message: data.result.message,
                type: 'error',
                showCloseButton: true,
                hideAfter: 10,
                hideOnNavigate: true,
                id: '1',
              });

              data.context.remove();
            }

            // $(this).parent('span').find('i, img').remove();
            //pictureCallback();
          },
          progress: function(e, data) {
            let progress = parseInt((data.loaded / data.total) * 100, 10);
            data.context
              .find('.progress-bar')
              .css('width', progress + '%')
              .attr('aria-valuenow', progress)
              .children('span')
              .html(progress);
          },
        })
        .on('fileuploadadd', function(e, data) {
          $('#image-tabs a#link-uploaded').tab('show');

          // console.warn(data);
          $.each(data.files, function(index, file) {
            let node = picturePlaceholder.clone(true);
            data.context = node;

            node.data(data).appendTo('#uploaded .attachments');
          });
        })
        .prop('disabled', !$.support.fileInput)
        .parent()
        .addClass($.support.fileInput ? undefined : 'disabled');

      $(document).bind('dragover', function(e) {
        let dropZone = $('.dropzone'),
          timeout = window.dropZoneTimeout;
        if (!timeout) {
          dropZone.addClass('in');
        } else {
          clearTimeout(timeout);
        }

        let found = false,
          node = e.target;
        do {
          if (node === dropZone[0]) {
            found = true;
            break;
          }
          node = node.parentNode;
        } while (node != null);
        if (found) {
          dropZone.addClass('hover');
        } else {
          dropZone.removeClass('hover');
        }

        window.dropZoneTimeout = setTimeout(function() {
          window.dropZoneTimeout = null;
          dropZone.removeClass('in hover');
        }, 100);
      });
    };

    toggleInsertButton = enable => {
      enable
        ? $(top.document.getElementById('insert-image')).removeClass('mce-disabled')
        : $(top.document.getElementById('insert-image')).addClass('mce-disabled');

      $(top.document.getElementById('insert-image').firstChild).attr('disabled', !enable);
    };

    toggleInsertVideoButton = enable => {
      enable
        ? $(top.document.getElementById('insert-video')).removeClass('mce-disabled')
        : $(top.document.getElementById('insert-video')).addClass('mce-disabled');

      $(top.document.getElementById('insert-video').firstChild).attr('disabled', !enable);
    };

    selectAttachment = e => {
      let markup = '<div class="attachment-details">';
      markup += sprintf('<img class="img-fluid" src="%s">', e.find('img').prop('src'));
      markup += sprintf('<span class="filename">%s</span>', e.data('filename'));
      markup += sprintf('<span class="note text-muted dimension">%s</span>', e.data('dimension'));
      markup += sprintf(
        '<a class="btn btn-sm btn-danger remove-file mt" href="%s" id="remove-file" data-id="%s">Delete image</a>',
        e.data('url-remove'),
        e.data('id'),
      );
      markup += '</div>';

      markup +=
        '<div class="attachment-setting"><div class="form-compact clearfix"><div class="form-group"><label class="control-label">Alignment</label>';
      markup +=
        '<select id="attachment-alignment" class="form-control input-sm"><option value="left">Left</option><option value="center">Center</option><option value="right">Right</option><option selected="selected" value="none">None</option></select>';
      markup += '</div>';
      markup += '<div class="form-group"><label class="control-label">Size</label>';
      markup +=
        '<select id="attachment-size" class="form-control input-sm"><option value="small">Small - 60 &times; 40</option><option value="normal">Medium - 300 &times; 250</option><option value="big">Large - 500 &times; 350</option><option selected="selected" value="full">Full - original</option></select>';
      markup += '</div></div></div></div>';

      $('.attachment-sidebar').html(markup);

      $('input#attachment-path').val(e.data('path'));
      $('input#attachment-src').val($('input#attachment-path').val() + e.data('filename'));
      $('input#attachment-basename').val(e.data('basename'));
      $('input#attachment-name').val(e.data('name'));
      $('input#attachment-ext').val(e.data('ext'));

      toggleInsertButton(true);
    };

    bindYoutube = () => {
      $('#container').on('input', '#youtube-url', function() {
        if ($(this).val().length == 0) {
          toggleInsertVideoButton(false);
        }

        loadVideo($(this));
      });
    };

    loadVideo = $e => {
      if ($e.val().length > 10) {
        $('#youtube-preview')
          .empty()
          .show();

        /*
                (?:https?:\/{2})? // Optional protocol, if have, must be http:// or https://
                (?:w{3}\.)?      // Optional sub-domain, if have, must be www.
                youtu(?:be)?  // The domain. Match 'youtu' and optionally 'be'.
                \.(?:com|be) // the domain-extension must be .com or .be
                (?:\/watch\?v=|\/)([^\s&]+) //match the value of 'v' parameter in querystring from 'watch' directory OR after root directory, any non-space value.
                */
        let videoid = $e
          .val()
          .match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);

        if (videoid != null) {
          // 	    		$.getJSON(sprintf("http://gdata.youtube.com/feeds/api/videos/%s?v=2&prettyprint=true&alt=jsonc", videoid[1]), function(json){

          $.getJSON(
            sprintf(
              'https://www.googleapis.com/youtube/v3/videos?id=%s&key=%s&part=snippet',
              videoid[1],
              settings.youtube.api_key,
            ),
            function(json) {
              $('<img/>')
                .attr('src', json.items[0].snippet.thumbnails.default.url)
                .appendTo('#youtube-preview');
              $('<div class="video-meta"/>')
                .append(
                  $('<a class="video-title" target="blank"/>')
                    .attr('href', $('#url').val())
                    .html(json.items[0].snippet.title),
                )
                .append($('<span class="text-sm text-muted"/>').html('youtube.com'))
                .append($('<p/>').html(json.items[0].snippet.description.substring(0, 255)))
                .appendTo('#youtube-preview');
            },
          );

          $e.parents('.form-group:first')
            .removeClass('has-error')
            .find('.invalid-feedback')
            .html('');

          toggleInsertVideoButton(true);
        } else {
          $e.parents('.form-group:first')
            .addClass('has-error')
            .find('.invalid-feedback')
            .html('Invalid Youtube video URL');
          $('#youtube-preview').hide();

          toggleInsertVideoButton(false);
        }
      }
    };
  };

  $.dialogFrame = function(options) {
    return new DialogFrame(null, options);
  };
})(jQuery);
